const currentURL = window.location.href;
let configOption = "development";
let instrumentKey = "";
const config = {
  localhost: {
    api: {
      url: "http://localhost:3002"
    }
  },
  development: {
    api: {
      url: "https://wc-admin-api-dev.caravanstudiosapps.org/"
    },
    applicationInsight: {
      instrumentationKey: "5a69a5fb-9979-49ab-b5b5-693c69aaae95"
    }
  },
  stage: {
    api: {
      url: "https://wc-admin-api-stage.caravanstudiosapps.org/"
    },
    applicationInsight: {
      instrumentationKey: "b0ab31bd-4e5e-42a2-9af2-1f5281ee55bc"
    }
  },
  live: {
    api: {
      url: "https://wc-admin-api.caravanstudiosapps.org"
    },
    applicationInsight: {
      instrumentationKey: "51651dff-2735-4bcd-8c95-5a219ba26b03"
    }
  }
};

switch (true) {
  case /localdev/.test(currentURL):
  case /localhost/.test(currentURL):
    configOption = "localhost";
    break;
  case /dev/.test(currentURL):
    configOption = "development";
    break;
  case /stage/.test(currentURL):
    configOption = "stage";
    break;
  case /wc/.test(currentURL):
    configOption = "live";
    break;
  default:
    configOption = "live";
    break;
}

export const API_URL = config[configOption].api.url;
if (
  config[configOption].applicationInsight &&
  config[configOption].applicationInsight.instrumentationKey
) {
  instrumentKey = config[configOption].applicationInsight.instrumentationKey;
}
export const INSTRUMENT_KEY = instrumentKey;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/config.ts